module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Mis Boletas")]), _c('p'), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "filtros"
  }, [_c('div', {
    staticClass: "filtro"
  }, [_c('div', {
    staticClass: "title-singular"
  }, [_c('p', [_vm._v("Selecciona un año")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterPeriodo),
      expression: "filterPeriodo"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterPeriodo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.periodos), function(o) {
    return _c('option', {
      domProps: {
        "value": o
      }
    }, [_vm._v(_vm._s(o))])
  }), 0)])])])]), (!_vm.isLoading) ? _c('div', {
    staticClass: "center"
  }, [(_vm.boletas.length === 0) ? _c('div', {
    staticClass: "article message is-info margin-top-10"
  }, [_vm._m(0)]) : _vm._e(), _vm._l((_vm.boletas), function(o) {
    return (_vm.boletas.length > 0) ? _c('div', {
      staticClass: "box"
    }, [_c('boleta-item-lista', {
      attrs: {
        "boleta": o
      },
      on: {
        "ver": _vm.verPdf,
        "refresh": _vm.fetch
      }
    })], 1) : _vm._e()
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activateFrame) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cerrarFrame),
      expression: "cerrarFrame"
    }],
    staticClass: "contenedor-frame"
  }, [_c('div', {
    staticClass: "titulo"
  }, [_c('span', {
    staticClass: "texto"
  }, [_vm._v(_vm._s(_vm.tituloFrame))]), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.cerrarFrame
    }
  }, [_c('span', [_vm._v("Cerrar")])])]), _c('iframe', {
    attrs: {
      "src": _vm.path
    }
  }, [_vm._v("Oops! an error has occurred.")])]) : _vm._e()])], 2) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "center"
  }, [_c('loading')], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No tiene boletas generadas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f0d94c3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Mis_Boletas.vue
// module id = 900
// module chunks = 0